import get from 'lodash/get';
import { connect } from 'react-redux';

import SelectPersonComponent from './SelectPersonComponent';

import { SELECT_EXISTING_CLEAR_PEOPLE } from '../../actionConstants';

const mapStateToProps = (state) => {
  const people = get(state, 'selectExisting.people');
  return {
    people,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onCancel: () => {
    // Added for BrokerFormComponent and VisitorFormComponent to close warning
    ownProps.onCancel && ownProps.onCancel();
    dispatch({
      type: SELECT_EXISTING_CLEAR_PEOPLE,
    });
  },
  onUnmount: () => {
    dispatch({ type: SELECT_EXISTING_CLEAR_PEOPLE });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectPersonComponent);
